import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoadingSpinner from '../utility/LoadingSpinner';
import PlayButton from '../../images/icons/PlayButt.png';
import { withTranslation } from 'react-i18next';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const carouselBgStyle = ( url) => { // eslint-disable-line
  return {
    background: `url(${url}) no-repeat center/cover`
  };
};

class PastExperiences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoID: '',
    };
    this.bannerSlider = React.createRef();
    this.getYoutubeID = this.getYoutubeID.bind(this);
    this.togglePopUpVideo = this.togglePopUpVideo.bind(this);
  }

  getYoutubeID(url){
    if(url){
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);

      if (match && match[2].length == 11) {
        return match[2];
      } else {
        console.log("Unable to process Youtube URL: ", url);
        return 'error';
      }
    }
  }

  togglePopUpVideo(id){
    if (id){
      this.setState({videoID: id});
    }
    else{
      this.setState({videoID: ''});
    }
  }

  render() {
    const { error, loading } = this.props;

    const pastExperiencesVideo = [
      {
        videoUrl: 'https://www.youtube.com/embed/Hip4eiB9zOk?si=NOgjZzl9yHicl80K',
        videoID: '',
        title: 'Live The Ranger Life'
      },
      {
        videoUrl: 'https://www.youtube.com/embed/Iv_uYPBicMI?si=PwfYJkIJv0n9k11p3',
        videoID: '',
        title: 'Ford Ranger Getaways | Sepang Training Experience'
      },
      {
        videoUrl: 'https://www.youtube.com/embed/ErkqdG7P-l4?si=IWC_8e21HXdEpm6V',
        videoID: '',
        title: 'Ford Ranger Getaways | 2-In-1 Off Road Course with Durian Buffet'
      },
      {
        videoUrl: 'https://www.youtube.com/embed/479W9jDIiYA?si=VDORU6WpBVS8QSXW',
        videoID: '',
        title: 'Ford Ranger Getaways | M4TREC Beginner 4WD Course'
      },
      {
        videoUrl: 'https://www.youtube.com/embed/tY2wngGiWnI?si=_fzcFUFUH7XYRVGu',
        videoID: '',
        title: 'Ford Ranger Getaways | Ford Ranger Training Experience - Sabah'
      }
    ];

    pastExperiencesVideo.forEach((video) => {
      video.videoID = this.getYoutubeID(video.videoUrl);
    });

    const slideSettings = {
      // autoplaySpeed: 0,
      // cssEase = 'linear',
      // centerMode: true,
      // variableWidth: true,
      // centerPadding = '60px',
      swipeToSlide: true,
      pauseOnHover: true,

      // slidesToShow: 1,
      // slidesToScroll: 1,
      // autoplay: true,
      // speed: 10000,
      // infinite: true,
      // dots: false,

      dots: true,
      infinite: true,
      speed: 1000,
      autoplay: true,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
          },
        }
      ]
    };

    if(loading) {
      return (
        <LoadingSpinner />
      );
    }
    if(error || !pastExperiencesVideo || pastExperiencesVideo.length < 1) {
      return null;
    }
    return (
      <>
        {/* Youtube Popup */}
        <div
          className={`fe-overlay video-popup ${(this.state.videoID) ? ' show' : ''}`}
          onClick={() => this.togglePopUpVideo(false)}
        />
        <div
          className={`fe-video-popup-container ${(this.state.videoID) ? ' show' : ''}`}
          tabIndex='0'
        >
          <div className="video-responsive">
            <iframe
              width='853'
              height='480'
              src={'//www.youtube.com/embed/' + this.state.videoID}
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
              title='Embedded youtube'
            />
          </div>
        </div>
        {/* Youtube Popup */}

        <section className='fe-past-experiences'>
          <div className='container'>
            <h3 className='fe-home-subheading'>Past Experiences</h3>
          </div>
          <div className=''>
            <Slider {...slideSettings}
            >
              {pastExperiencesVideo.map((video, i) => {
                return (
                  <div key = {i} className='fe-past-experiences-card'>
                    <div className='fe-past-experiences-container'>
                      <div
                        className='fe-video-overlay-play'
                      >
                        <button className='fe-play-button' onClick={() => this.togglePopUpVideo(video.videoID)}>
                          <img src={PlayButton}/>
                          <div className='fe-video-title'>{video.title}</div>
                        </button>
                      </div>
                      <div
                        className='fe-past-experiences-thumbnail'
                        style={carouselBgStyle('https://img.youtube.com/vi/' + video.videoID + '/maxresdefault.jpg')}
                        onClick={() => this.togglePopUpVideo(video.videoID)}
                      />
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </section>
      </>
    );
  }
}

PastExperiences.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ storiesState }) => ({
  loading: storiesState.loading,
  error: storiesState.error
});

const mapDispatchToProps = {
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PastExperiences));
